import React, { Component } from 'react';
type Tone = 'green' | 'orange' | 'red' | 'empty';
interface Component {
  label: string;
  title: string;
  score: number;
  tone: Tone;
  desc: string;
}
const COMPONENTS: Component[] = [{
  label: 'Viziune',
  title: 'Viziune & Strategie',
  score: 8,
  tone: 'green',
  desc: 'Direcția clară a companiei pe 1, 3 și 10 ani, cu un plan concret care o face reală.'
}, {
  label: 'Oameni',
  title: 'Oameni & Roluri',
  score: 3,
  tone: 'red',
  desc: 'Organigramă funcțională, fișe de rol clare și o matrice de responsabilități pentru fiecare om.'
}, {
  label: 'Numere',
  title: 'Numere & KPI',
  score: 0,
  tone: 'empty',
  desc: 'Un tablou de bord simplu cu indicatorii care contează, ca să conduci pe cifre reale, nu pe impresii.'
}, {
  label: 'Procese',
  title: 'Procese',
  score: 0,
  tone: 'empty',
  desc: 'Procese critice documentate, astfel încât orice om nou să poată performa în timp scurt.'
}, {
  label: 'Probleme',
  title: 'Rezolvare Probleme',
  score: 6,
  tone: 'orange',
  desc: 'Identificăm și rezolvăm problemele recurente de la rădăcină, o dată pentru totdeauna.'
}, {
  label: 'Progres',
  title: 'Progres & Follow-up',
  score: 7,
  tone: 'orange',
  desc: 'Un ritm constant de urmărire: ședințe săptămânale, trimestriale și anuale.'
}, {
  label: 'Cash',
  title: 'Cash & Financiar',
  score: 10,
  tone: 'green',
  desc: 'Bani, marje și cashflow sub control — combustibilul creșterii, vizibil în 15 minute.'
}, {
  label: 'Mentalitate',
  title: 'Mentalitate & Leadership',
  score: 5,
  tone: 'orange',
  desc: 'De la „totul depinde de mine", la un sistem care merge și fără tine în fiecare zi.'
}];
const TONE_STYLES: Record<Tone, {
  bar: string;
  badge: string;
  dot: string;
}> = {
  green: {
    bar: 'bg-gradient-to-b from-[#22C55E] to-[#15803D]',
    badge: 'text-white',
    dot: 'bg-[#16A34A]'
  },
  orange: {
    bar: 'bg-gradient-to-b from-[#F97316] to-[#C2410C]',
    badge: 'text-white',
    dot: 'bg-[#EA580C]'
  },
  red: {
    bar: 'bg-gradient-to-b from-[#EF4444] to-[#B91C1C]',
    badge: 'text-white',
    dot: 'bg-[#DC2626]'
  },
  empty: {
    bar: 'border-2 border-dashed border-[#DC2626] bg-[rgba(220,38,38,0.06)]',
    badge: 'text-[#DC2626]',
    dot: 'bg-[#DC2626]'
  }
};
export function ProviInfographic() {
  return <div className="mb-16 md:mb-20" data-id="element-142" data-mp="2hyvf8v1dhbic">
      {/* BAR CHART */}
      <div className="bg-[#FAFAF9] border border-[rgba(0,0,0,0.06)] rounded-3xl p-6 md:p-10 shadow-[0_12px_40px_rgba(0,0,0,0.04)] mb-14 md:mb-20" data-id="element-143" data-mp="2hxagsubxt8f7">
        <div className="flex items-end justify-between gap-2 md:gap-4 h-[280px] md:h-[340px] border-b-2 border-[#CBD5E1] relative" data-id="element-144" data-mp="1q90em282dzed">
          {/* Gridlines */}
          <div className="absolute inset-x-0 top-0 bottom-[0] flex flex-col justify-between pointer-events-none" data-id="element-145" data-mp="241ggv0t55te8">
            {[0, 1, 2, 3].map(n => <div key={n} className="w-full border-t border-dashed border-[rgba(0,0,0,0.05)]" data-id="element-146" data-mp="1bijbmefs71fd" />)}
          </div>
          {COMPONENTS.map((c, i) => {
          const tone = TONE_STYLES[c.tone];
          const isEmpty = c.tone === 'empty';
          const heightPct = isEmpty ? 6 : Math.max(c.score / 10 * 100, 8);
          return <div key={i} className="relative z-10 flex-1 flex flex-col items-center justify-end h-full" data-id="element-147" data-mp="3mzuy0cgmygtr" data-mpi={i}>
                <div className={`relative w-full max-w-[64px] rounded-t-md ${tone.bar} flex items-start justify-center transition-all duration-700 ease-out ${isEmpty ? 'rounded-md' : 'shadow-[0_-2px_10px_rgba(0,0,0,0.08)]'}`} style={{
              height: `${heightPct}%`
            }} data-id="element-148" data-mp="398gbvwrflzih">
                  {!isEmpty && <div className="pt-2 text-center leading-none" data-id="element-149" data-mp="9qywwezi968n">
                      <span className="font-['Montserrat'] text-[18px] md:text-[22px] font-extrabold text-white" data-id="element-150" data-mp="3rwbmj7rqyx7d">
                        {c.score}
                      </span>
                      <span className="block font-['Inter'] text-[9px] md:text-[10px] text-white/70 -mt-0.5" data-id="element-151" data-mp="2ghompj8sab4n">
                        /10
                      </span>
                    </div>}
                </div>
              </div>;
        })}
        </div>
        {/* Labels */}
        <div className="flex items-start justify-between gap-2 md:gap-4 mt-3" data-id="element-152" data-mp="30ssf6o6cps0w">
          {COMPONENTS.map((c, i) => <div key={i} className="flex-1 text-center" data-id="element-153" data-mp="2rynllwzu22ho" data-mpi={i}>
              <span className={`font-['Montserrat'] text-[10px] md:text-[13px] font-bold ${c.tone === 'empty' || c.tone === 'red' ? 'text-[#DC2626]' : 'text-[#334155]'}`} data-id="element-154" data-mp="2rz5o3bd39cy1">
                {c.label}
              </span>
            </div>)}
        </div>
        <div className="text-right mt-2" data-id="element-155" data-mp="3fohxoccbvn0v">
          <span className="font-['Inter'] text-[11px] md:text-[12px] font-semibold text-[#3B82F6] italic" data-id="element-156" data-mp="3fpjhb57ethu7">
            Nivel
          </span>
        </div>
      </div>

      {/* EXPLANATION BOXES — 2 per row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-157" data-mp="35psor92etcwr">
        {COMPONENTS.map((c, i) => {
        const tone = TONE_STYLES[c.tone];
        return <div key={i} className="bg-white border border-[rgba(0,0,0,0.06)] rounded-2xl p-6 flex items-start gap-4 hover:shadow-[0_10px_30px_rgba(0,0,0,0.05)] transition-shadow duration-300" data-id="element-158" data-mp="1ub5fyv1gxghw" data-mpi={i}>
              <div className={`w-3 h-3 rounded-full flex-shrink-0 mt-1.5 ${tone.dot}`} data-id="element-159" data-mp="1p5s3zis8fzkh" />
              <div data-id="element-160" data-mp="1u54ss92nzgpp">
                <h4 className="font-['Montserrat'] text-[16px] font-bold text-[#09111F] mb-1.5" data-id="element-161" data-mp="1u4l7cidt2a6x">
                  {c.title}
                </h4>
                <p className="font-['Inter'] text-[15px] font-light text-[#4B5563] leading-[1.6]" data-id="element-162" data-mp="1yx60dhow0j9e">
                  {c.desc}
                </p>
              </div>
            </div>;
      })}
      </div>
    </div>;
}